import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, Container, Form, Image } from "react-bootstrap";
import ComponentLoader from "../../layout/ComponentLoader";
import { apiGetOrgunits } from "../../../api/ApiOrgunit";
import { MdOutlineCancel, MdOutlineSearch, MdFiberNew, MdOutlineMoreHoriz } from "react-icons/md";
import { apiGetPersonnes } from "../../../api/ApiPersonnes";
import { trouveMotDebutantParSearchDansPhrase } from "../../../utils/search";
import { apiBandeauxColidee } from "../../../api/ApiColidee";
import { dateDiff, dateJour, toDateParseEN } from "../../../utils/datesHeures";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";

import {
  BsSortAlphaDown,
  BsSortAlphaUpAlt,
  BsSortNumericDown,
  BsSortNumericUp,
} from "react-icons/bs";
import { apiGetMarques } from "../../../api/ApiMarque";
import { apiGetEngagements } from "../../../api/ApiEngagement";
import { tronquer } from "../../../utils/string";

const BlocSousMissions = (props) => {
  const { t } = useTranslation();
  const { orgunitParent } = props;
  const [loader, setLoader] = useState(false);
  const [activeInterne, setActiveInterne] = useState(false);
  const [activeExterne, setActiveExterne] = useState(true);
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(true);
  const [filtreOrgunitsByPersonne, setFiltreOrgunitsByPersonne] = useState([]);

  const [seeOnlyNewOrgUnits, setSeeOnlyNewOrgUnits] = useState(false);
  const [triBy, setTriBy] = useState("nomAsc");
  const [marquePrincipale, setMarquePrincipale] = useState(null);
  const [engagements, setEngagements] = useState([]);
  const [filtreEngagements, setFiltreEngagements] = useState("null");

  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);

  const [orgunitsCopy, setOrgunitsCopy] = useState([]);
  const [orgunits, setOrgunits] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [orgunitSelected, setOrgunitSelected] = useState("");

  // on recupere toutes les personnes de la BDD
  const recupPersonnes = async () => {
    const res = await apiGetPersonnes(
      ReduxInstance._id,
      "include=marque,localisations,orgUnitsParent"
    );
    res.data.forEach((personne) => {
      personne.orgUnitsParentIdToArray = [];
      personne.orgUnitsParent.forEach((orgUnit) => {
        personne.orgUnitsParentIdToArray.push(orgUnit._id);
      });
    });
    setPersonnes(res.data);
  };

  // on recupere tous les orgunit de la BDD ayant un chap orgunitparent contenant celui de la props
  const recupOrgUnits = async () => {
    setLoader(true);

    const res = await apiGetOrgunits(ReduxInstance._id, "filter[orgUnitParent]=" + orgunitParent);
    let orgunitsOrigine = res.data;
    orgunitsOrigine.map((item, index) => (item.nbPersonnes = nbrPersonnesInOrgunit(item._id)));

    // etape 1 on va demander préparer un tableau d'espaces colidée qui sont censés etre listé dans ces orgunits
    let espacesColidee = [];
    const regex = /(https:\/\/colidee.com\/)/g;
    orgunitsOrigine.forEach((orgunit, index) => {
      orgunit.liens
        .filter((lien) => lien.icone === "colidee")
        .forEach((lienColidee, index) => {
          const found = lienColidee.url.match(regex);
          if (found) espacesColidee.push(lienColidee.url);
        });
    });
    // etape 2 si on a des liens Colidée référencés, alors on va demander en API à Colidée si il y a un bandeau image associé et ensuitre attribuer à chaque lien colidée une image associée
    if (espacesColidee.length) {
      const myForm = new FormData();
      myForm.append("espacesColidee", espacesColidee);
      const retourColidee = await apiBandeauxColidee(ReduxToken, myForm);
      orgunitsOrigine.forEach((orgunit, index) => {
        orgunit.liens
          .filter((lien) => lien.icone === "colidee")
          .forEach((lienColidee, index) => {
            const found = lienColidee.url.match(regex);
            if (found) {
              let match = lienColidee.url.match(/o([0-9]+)(p([0-9]+))*/);
              let idOrga = match[1];
              let idEspace = match[3];
              let indexDeTest = null;
              if (idOrga) {
                indexDeTest = "o" + idOrga;
                if (idEspace) {
                  indexDeTest += "p" + idEspace;
                }
              }
              if (retourColidee.data[indexDeTest])
                lienColidee.picture = retourColidee.data[indexDeTest];
            }
          });
      });
    }

    setOrgunits(orgunitsOrigine.filter((item) => item.enSommeil !== true));
    setOrgunitsCopy(
      orgunitsOrigine.filter((item) => item.enSommeil !== true && item.scope === "Externe")
    );

    setLoader(false);
  };

  // permet de récupérer les marques d'organisatoin et voir si il y en a une de principale en vue de separer equipe interne et externe
  const recupMarques = async () => {
    let marquePinned = [];
    const res = await apiGetMarques(ReduxInstance._id);
    marquePinned = res.data.filter((item) => item.pinned);
    if (marquePinned.length >= 1) {
      setMarquePrincipale(marquePinned);
    }
  };

  // permet de récupérer les engagement
  const recupEngagements = async () => {
    const res = await apiGetEngagements(ReduxInstance._id);
    setEngagements(res.data);
  };

  const cancelFiltres = () => {
    setShowSearch(true);
    setActiveExterne(true);
    setActiveInterne(false);
    setSeeOnlyNewOrgUnits(false);
    setSearch("");
    setOrgunitSelected("");
    setFiltreOrgunitsByPersonne([]);
    setFiltreEngagements("null");
  };

  const nbrPersonnesInOrgunit = (idOrgunit) => {
    const personnesFiltrees = personnes.filter((personne) =>
      personne.orgUnitsParentIdToArray.includes(idOrgunit)
    );
    return personnesFiltrees.length;
  };

  useEffect(() => {
    let orgUnitsFiltres = [...orgunits];
    let orgUnitsInternes = [];
    let orgUnitsExternes = [];

    if (seeOnlyNewOrgUnits) {
      orgUnitsFiltres = orgUnitsFiltres.filter(
        (orgunit) => tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15
      );
    }

    if (filtreEngagements !== "null") {
      let filtreEngagementsArray = filtreEngagements.split(",");
      orgUnitsFiltres = orgUnitsFiltres.filter((orgunit) =>
        filtreEngagementsArray.includes(orgunit._id)
      );
    }

    if (activeInterne) {
      orgUnitsInternes = orgUnitsFiltres.filter((orgunit) => orgunit.scope === "Interne");
    }

    if (activeExterne) {
      orgUnitsExternes = orgUnitsFiltres.filter((orgunit) => orgunit.scope === "Externe");
    }

    orgUnitsFiltres = orgUnitsInternes.concat(orgUnitsExternes);

    if (search) {
      let orgunitsStartWith = [];
      orgUnitsFiltres.forEach((orgunit) => {
        if (trouveMotDebutantParSearchDansPhrase(search, orgunit)) {
          orgunitsStartWith.push(orgunit);
        }
      });
      orgUnitsFiltres = orgunitsStartWith;
    }

    if (filtreOrgunitsByPersonne.length > 0) {
      // on recupère ici le tableau des orgunit dans lesquels se trouve cette personne et on ne conserve que ceux dont il fait parti
      let orgunitsContainPerson = [];
      orgUnitsFiltres.forEach((orgunit) => {
        if (filtreOrgunitsByPersonne.includes(orgunit._id)) {
          orgunitsContainPerson.push(orgunit);
        }
      });
      orgUnitsFiltres = orgunitsContainPerson;
    }

    if (triBy === "nomAsc")
      orgUnitsFiltres.sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0));
    if (triBy === "nomDesc")
      orgUnitsFiltres.sort((b, a) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0));
    if (triBy === "nbPersonnesAsc")
      orgUnitsFiltres.sort((a, b) =>
        a.nbPersonnes > b.nbPersonnes ? 1 : b.nbPersonnes > a.nbPersonnes ? -1 : 0
      );
    if (triBy === "nbPersonnesDesc")
      orgUnitsFiltres.sort((b, a) =>
        a.nbPersonnes > b.nbPersonnes ? 1 : b.nbPersonnes > a.nbPersonnes ? -1 : 0
      );

    setOrgunitsCopy(orgUnitsFiltres);
  }, [
    search,
    activeInterne,
    activeExterne,
    orgunitSelected,
    seeOnlyNewOrgUnits,
    triBy,
    filtreOrgunitsByPersonne,
    filtreEngagements,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleEtatBoutons = (bouton, etatActiveInterne, etatActiveExterne) => {
    if (bouton === "interne") {
      // si interne pas coche et externe coche on veut toggle entre interne et externe
      if (!etatActiveInterne && etatActiveExterne) {
        setActiveInterne(true);
        setActiveExterne(false);
      }
    }

    if (bouton === "externe") {
      // si externe pas coche et interne coche on veut toggle entre externe et interne
      if (etatActiveInterne && !etatActiveExterne) {
        setActiveInterne(false);
        setActiveExterne(true);
      }
    }
  };

  const hasNewOrgunits = () => {
    const newArray = orgunits.filter(
      (orgunit) => tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15
    );
    return newArray.length;
  };

  const tagNew = (orgunitDateCreation) => {
    if (orgunitDateCreation) {
      let diff = dateDiff(toDateParseEN(orgunitDateCreation), dateJour());
      return diff.day;
    }
  };

  // permet de récupérer les personnes dans un orgunit donné, et en fonction du type "interne" ou "externe"  ==> depend si l'on a une organisation/marque principale ou pas
  const afficheTypePersonnesInOrgunit = (idOrgunit, type) => {
    let personnesByOrgunit = [...personnes];
    personnesByOrgunit = personnesByOrgunit.filter((personne) =>
      personne.orgUnitsParentIdToArray.includes(idOrgunit)
    );

    if (type === "interne" && marquePrincipale)
      personnesByOrgunit = personnesByOrgunit.filter(
        (personne) => marquePrincipale.filter((item) => item._id === personne.marque._id).length
      );
    if (type === "externe" && marquePrincipale)
      personnesByOrgunit = personnesByOrgunit.filter(
        (personne) =>
          marquePrincipale.filter((item) => item._id === personne.marque._id).length === 0
      );

    return personnesByOrgunit.map((personne, index) => (
      <Card.Img
        key={"personne_" + personne._id}
        role="button"
        className="avatar"
        variant="top"
        onClick={(e) => setFiltreOrgunitsByPersonne(personne.orgUnitsParentIdToArray)}
        title={personne.prenom + " " + personne.nom}
        src={
          personne.profilePic
            ? process.env.REACT_APP_URL_EXPRESS + "images/avatar/small/" + personne.profilePic
            : genericAvatar
        }
      />
    ));
  };

  // lance a la verification de l'existence ou non du orgunit prevu (au cas ou il ait ete supprime)
  // on cherche les personnes en premier avant de lancer la recherche des orgunit sur le useEffect sinon on peut pâs calculer le Nbr de personnes dans le groupe
  useEffect(() => {
    if (orgunitParent) {
      recupPersonnes();
      recupMarques();
      recupEngagements();
    }
  }, [orgunitParent]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (orgunitParent) {
      recupOrgUnits();
    }
  }, [personnes]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <Container fluid className="mt-1 mb-1">
          {orgunitParent && orgunits.length > 0 && (
            <>
              <Container
                fluid
                className="mb-3 d-flex  align-items-center flex-wrap containerFiltresSousOrgUnit"
              >
                {
                  <div className="m-1  align-items-center d-flex">
                    <Form.Check
                      className={activeInterne && !activeExterne ? "filtreActif" : "filtreNonActif"}
                      type="checkbox"
                      label={t("public.filtres.filtre15")}
                      id="interne"
                      name="Interne"
                      onChange={(e) => {
                        toggleEtatBoutons("interne", activeInterne, activeExterne);
                      }}
                      checked={activeInterne ? "checked" : ""}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  </div>
                }
                {
                  <div className="m-1 align-items-center d-flex">
                    <Form.Check
                      className={!activeInterne && activeExterne ? "filtreActif" : "filtreNonActif"}
                      type="checkbox"
                      label={t("public.filtres.filtre16")}
                      id="externe"
                      name="Externe"
                      onChange={(e) => {
                        toggleEtatBoutons("externe", activeInterne, activeExterne);
                      }}
                      checked={activeExterne ? "checked" : ""}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  </div>
                }
                {hasNewOrgunits() > 0 && (
                  <div
                    className={
                      seeOnlyNewOrgUnits
                        ? "d-flex m-2 align-items-center d-flex m-2 align-items-center filtreActif"
                        : "d-flex m-2 align-items-center"
                    }
                  >
                    <MdFiberNew
                      size="2em"
                      role="button"
                      onClick={(e) => setSeeOnlyNewOrgUnits(!seeOnlyNewOrgUnits)}
                    />
                  </div>
                )}

                <BsSortAlphaDown
                  size="1.6em"
                  onClick={(e) => setTriBy("nomAsc")}
                  role="button"
                  className={triBy === "nomAsc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />

                <BsSortAlphaUpAlt
                  size="1.6em"
                  onClick={(e) => setTriBy("nomDesc")}
                  role="button"
                  className={triBy === "nomDesc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />
                <BsSortNumericDown
                  size="1.6em"
                  onClick={(e) => setTriBy("nbPersonnesAsc")}
                  role="button"
                  className={triBy === "nbPersonnesAsc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />
                <BsSortNumericUp
                  size="1.6em"
                  onClick={(e) => setTriBy("nbPersonnesDesc")}
                  role="button"
                  className={triBy === "nbPersonnesDesc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />

                <div className="m-1 p-1 align-items-center d-flex border">
                  <MdOutlineSearch
                    size="1.6em"
                    onClick={(e) => setShowSearch(!showSearch)}
                    role="button"
                  />
                  {showSearch && (
                    <Form.Control
                      type="text"
                      placeholder={t("public.filtres.filtre19")}
                      size="50"
                      name="search"
                      value={search}
                      className="border-0 form-control-sm"
                      onChange={(e) => setSearch(e.target.value)}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  )}
                </div>
                {engagements.length > 0 && (
                  <div className="m-1 p-1 align-items-center d-flex ">
                    <Form.Select onChange={(e) => setFiltreEngagements(e.target.value)}>
                      <option
                        value="null"
                        selected={filtreEngagements === "null" ? "selected" : ""}
                      >
                        {t("public.filtres.filtre21")}
                      </option>
                      {engagements.map((engagement, index) => (
                        <option value={engagement.orgUnits} key={index}>
                          {engagement.nom}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                )}
                {(search ||
                  seeOnlyNewOrgUnits ||
                  filtreOrgunitsByPersonne.length > 0 ||
                  filtreEngagements !== "null") &&
                  !orgunitSelected && (
                    <div className="d-flex m-2 align-items-center  ">
                      <MdOutlineCancel
                        size="1.5em"
                        role="button"
                        onClick={() => cancelFiltres()}
                        className="ms-2 text-danger"
                      />
                    </div>
                  )}
              </Container>
              <div className="containerMissionsInOperation p-2">
                {orgunitsCopy.map((orgunit, index) => (
                  <div
                    className="orgUnitInOperation p-1 d-flex align-items-start"
                    key={orgunit._id}
                  >
                    <div className="flex-grow-1 d-flex">
                      <span style={{ width: "100%" }} className="me-5">
                        {(tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15) && (
                          <MdFiberNew size="2em" role="button" className="iconNewOrgUnit" />
                        )}
                        <span className="fw-bold"> {orgunit.nom}</span>
                        <div className="fst-italic" style={{ whiteSpace: "pre-wrap" }}>
                          {tronquer(orgunit.descriptionReelle, 150)}
                        </div>
                      </span>
                      <span style={{ width: "30%" }} className="d-none d-xl-block d-lg-block">
                        {orgunit.liens.filter((lien) => lien.icone === "colidee").length > 0 && (
                          <>
                            <div className="emplacementbandeauEspaces">
                              {orgunit.liens
                                .filter((lien) => lien.icone === "colidee")
                                .map((lien, index) => (
                                  <a
                                    href={lien.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    key={"lienColidee_" + index}
                                  >
                                    <Image src={lien.picture} className="ms-2 me-2" />
                                  </a>
                                ))}
                            </div>
                            <div className="sousTitresSmall">
                              {t("public.componentMission.lesEspaces")}
                            </div>
                          </>
                        )}
                      </span>
                      {marquePrincipale && (
                        <>
                          <span style={{ width: "20%" }} className="d-none d-xl-block d-lg-block">
                            <div className="emplacementTrombiEspaces">
                              {afficheTypePersonnesInOrgunit(orgunit._id, "interne")}
                            </div>
                            <div className="sousTitresSmall">
                              {t("public.componentMission.LesEquipesInternes")}
                            </div>
                          </span>
                          <span style={{ width: "20%" }} className="d-none d-xl-block d-lg-block">
                            <div className="emplacementTrombiEspaces">
                              {afficheTypePersonnesInOrgunit(orgunit._id, "externe")}
                            </div>
                            <div className="sousTitresSmall">
                              {t("public.componentMission.LesEquipesExternes")}
                            </div>
                          </span>
                        </>
                      )}
                      {!marquePrincipale && (
                        <>
                          <span style={{ width: "40%" }} className="d-none d-xl-block d-lg-block">
                            <div className="emplacementTrombiEspaces">
                              {afficheTypePersonnesInOrgunit(orgunit._id, "")}
                            </div>
                            <div className="sousTitresSmall">
                              {t("public.componentMission.LesEquipes")}
                            </div>
                          </span>
                        </>
                      )}
                    </div>
                    <span className="d-flex flex-nowrap align-items-center">
                      <Link to={`/orgunits/${orgunit._id}`}>
                        <MdOutlineMoreHoriz size="2em" role="button" className="float-end " />
                      </Link>
                    </span>
                  </div>
                ))}
              </div>
              <br />
              <br />
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default BlocSousMissions;
